import { createContext, useContext, useEffect, useState } from "react";
import { xtreamLogin } from "@/lib/xtream";
import { setLastServer } from "@/lib/store";

const AuthContext = createContext(null);
const STORAGE_KEY = "xtream_session_v1";

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setSession(JSON.parse(raw));
    } catch (e) {
      // ignore corrupted storage
    }
    setReady(true);
  }, []);

  const login = async (creds) => {
    const data = await xtreamLogin(creds);
    const newSession = { creds, userInfo: data.user_info, serverInfo: data.server_info };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newSession));
    setLastServer(creds.server);
    setSession(newSession);
    return newSession;
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEY);
    setSession(null);
  };

  return (
    <AuthContext.Provider value={{ session, creds: session?.creds, login, logout, ready }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
